import React, { useState, useEffect, useRef } from 'react';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { useMaximize } from '@src/mobile/hooks/app';
import { isGrounds, groundsClose, openAppShare } from '@src/utils/app';
import { QQShare } from '@ifeng-fe/three_terminal/es/mobile/qqShare/dynamic';
import styles from './index.css';
import { setAppQuery, isMobile } from '@src/utils';

const cx = classNames.bind(styles);

const Banner = ({ shareTitle, shareDesc, shareThumbnail, showCallApp, showMask }) => {
    // 全屏且获取状态栏高度
    const statusBarHeight = useMaximize();

    // nav的ref
    const navRef = useRef();

    const handleBackClick = () => {
        groundsClose();
    };

    const handleShareClick = () => {
        openAppShare({
            title: shareTitle,
            desc: shareDesc,
            thumbnail: shareThumbnail,
        });
    };

    return (
        <>
            {isGrounds ? (
                <div className={styles.nav} style={{ paddingTop: statusBarHeight }} ref={navRef}>
                    <div className={styles.navContent}>
                        <div className={styles.navBack} onClick={handleBackClick} />
                        <div className={styles.navShare} onClick={handleShareClick} />
                    </div>
                    {showMask ? <div className={styles.mask} /> : null}
                </div>
            ) : null}
            {shareThumbnail ? <QQShare
                content={{
                    url: setAppQuery(`${window.location.origin}${window.location.pathname}`),
                    title: shareTitle,
                    img: shareThumbnail,
                    desc: shareDesc,
                    cb: () => {
                        console.log('分享成功');
                    },
                }}
            /> : null}
        </>
    );
};

Banner.propTypes = {
    shareTitle: PropTypes.string,
    shareDesc: PropTypes.string,
    shareThumbnail: PropTypes.string,
    showCallApp: PropTypes.boolean,
    showMask: PropTypes.boolean,
};

export default errorBoundary(Banner);
